export default {
  state: {
    ratingsByTerritory: {},
  },
  mutations: {
    set_territory_ratings(state, {key, ratings}) {
      state.ratingsByTerritory = {...state.ratingsByTerritory, [key]: ratings};
    },
  },
  actions: {
    cacheTerritoryRatings({commit}, {key, ratings}) {
      commit('set_territory_ratings', {key, ratings});
    },
  },
  getters: {
    getRatingsByTerritoryKey: (state) => (key) => {
      return state.ratingsByTerritory[key];
    },
  },
};
